import { useState } from 'react';

import { SlackChannel } from 'models';

import { LocalNotificationService } from 'services/LocalNotificationService';
import { SlackNotificationService } from 'services/SlackNotificationService';
import { TeamService } from 'services/TeamService';

import { SubscriptionUpdateCommonProps } from '../types';

export const useSubscriptionReleaseSchedule = ({ team, onClose, postSubmitAction }: SubscriptionUpdateCommonProps) => {
    const [loading, setLoading] = useState(false);

    const submitSubscriptionReleaseSchedule = async () => {
        setLoading(true);

        try {
            await TeamService.subscriptionReleaseSchedule(team.id);
            if (postSubmitAction) {
                postSubmitAction();
            }

            onClose();

            LocalNotificationService.showSuccess({ message: 'Resubscription successful' });

            TeamService.refresh(team.id);
        } catch (error) {
            console.error('Error releasing subscription schedule', error);
            LocalNotificationService.showError({ message: 'Error resubscribing' });

            SlackNotificationService.send(
                [
                    '*User Encountered Error Resubscribing*',
                    `Team: ${team.name} (${team.id})`,
                    `Error message: ${JSON.stringify(error)}`,
                ].join('\n'),
                SlackChannel.PAYMENT,
            );
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        submitSubscriptionReleaseSchedule,
    };
};
